function formDataStoreDirective(FormDataStoreService) {
    'ngInject';

    //  remove '?' when we change over the bbWidget directive
    return {
        require: '?bbWidget',
        link(scope) {
            return FormDataStoreService.register(scope);
        }
    };
}

// Form Data Store Directive  this does very little apart from register the
// widget, so the user's form choices are stored.
angular
    .module('BB')
    .directive('bbFormDataStore', formDataStoreDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/form-data-store/form_data_store.directive.js